var getAriaDescribedBy = props => {
  if (!props.displayError && !props.hasError) {
    return props.ariaDescribedBy;
  }

  var ariaDescribedBy = "".concat(props.id, "-error ").concat(props.ariaDescribedBy || '');
  return ariaDescribedBy.trim();
};

export { getAriaDescribedBy };